import { Component, Input } from '@angular/core';

@Component({
  selector: 'incomplete-banner',
  imports: [],
  templateUrl: './incomplete-banner.component.html',
})
export class IncompleteBannerComponent {

  @Input() userFirstName: string;

}
